import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiMenuSectionDTO,
  MenuSectionDTO,
} from "@lib/strapi/dtos/components/sections/menuSection.dto";

export class MenuSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiMenuSectionDTO,
  ): Promise<MenuSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new MenuSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.menu = strapiData.menu;
    dto.heading = strapiData.heading;
    dto.sticky = strapiData.sticky;
    dto.hideOnMobile = strapiData.hideOnMobile;
    return dto;
  }
}
